import { z } from 'zod/v3';

import { sortingDirectionSchema } from 'features/procurement/schema';

import { GrirListRequestParams, GrirSorting } from '../api-types';

const grirFiltersSchema = z.object({
  statuses: z.custom<GrirListRequestParams['statuses']>().optional(),
  substatuses: z.custom<GrirListRequestParams['substatuses']>().optional(),
  earliestUpdatedAt: z.string().optional(),
  latestUpdatedAt: z.string().optional(),
  earliestGoodsReceivedDate: z.string().optional(),
  latestGoodsReceivedDate: z.string().optional(),
  earliestInvoiceReceivedDate: z.string().optional(),
  latestInvoiceReceivedDate: z.string().optional(),
  vendorCodes: z.array(z.string()).optional(),
  countryCodes: z.array(z.string()).optional(),
  includes: z.custom<GrirListRequestParams['threeWayMatchFilter']>().optional(),
});

export const grirListRouteSearchSchema = z.object({
  ...grirFiltersSchema.shape,
  page: z.coerce.number().optional(),
  pageSize: z.coerce.number().optional(),
  q: z.coerce.string().optional(),
  sortBy: z.custom<GrirSorting>().optional(),
  sortingType: sortingDirectionSchema.optional(),
});

export type GrirFilters = z.infer<typeof grirFiltersSchema>;
